import { Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { UntrackedAssetCatalogPage } from '../../../features/entity-management';

export const Route = createFileRoute('/_auth/entity-management/untracked-asset-catalog')({
  staticData: {
    title: 'pages.entityManagement.title',
    description: 'pages.entityManagement.description',
  },
  component: UntrackedAssetCatalogRoute,
});

function UntrackedAssetCatalogRoute() {
  return (
    <Box
      sx={{
        px: { xs: '1rem', md: '1.5rem', lg: '3rem', xl: '3rem' },
        pb: '1.5rem',
      }}
    >
      <UntrackedAssetCatalogPage />
    </Box>
  );
}
